import React, { useState } from 'react';
import { withRouter } from 'react-router';
import { Layout } from 'antd';
import {
  BrowserRouter as Router, Route, Switch, useHistory,
} from 'react-router-dom';
import { connect } from 'react-redux';
import Aside from './Aside';
import Header from '../Header';
import OrderTransactionHistory from '../../containers/OrderTransactionHistoryContainer';
import LoginHistoryContainer from '../../containers/LoginHistoryContainer';
import ListUserContainer from '../../containers/ListUserContainer';
import SettingFeeTransaction from '../../containers/SettingFeeTransactionContainer';
import TransactionFee from '../../containers/TransactionFeeContainer';
import TransactionHistoryContainer from '../../containers/TransactionHistoryContainer';
import OrderHistoryContainer from '../../containers/OrderHistoryContainer';
import ListCoinOnFieldContainer from '../../containers/ListCoinOnFieldContainer';
import AdminManagementContainer from '../../containers/AdminManagementContainer';
import ToolsContainer from '../../containers/ToolsContainer';
import { PREFIX_FRONT_URL } from '../../consts';
import action from '../../redux/actions/login/index';
import {
  InOutOrderTransContainer,
  InOutTransContainer,
  InOutTransExternalContainer,
  WalletBalanceContainer,
} from '../../containers/StatisticContainer';
import HomeContainer from '../../containers/HomeContainer';
// import RoleManagementContainer from '../../containers/RoleManagementContainer';
import PermissionManagementContainer from '../../containers/PermissionManagementContainer';
// import PermissionActionManagementContainer
//   from '../../containers/PermissionActionManagementContainer';
import AffilateSettingContainer from '../../containers/AffilateSettingContainer';
import TransferMoneyContainer from '../../containers/TransferMoneyContainer';

// TODO Fix name
import LimitTransferMoneyContainer from '../../containers/LimitTransferMoneyContainer';
import AdminWalletBalanceContainer from '../../containers/AdminWalletBalanceContainer';
import CampaignContainer from '../../containers/CampaignContainer';
import LuckyGameConfigContainer from '../../containers/LuckyGameConfigContainer';
import NotificationContainer from '../../containers/NotificationContainer';
import AffilateStatisticContainer from '../../containers/AffilateStatisticContainer';
import LoginSetting from '../../containers/ShowCryptoSettingsContainer';
import TransactionError from '../../containers/TransactionErrorContainer';
import TransactionVerifyContainer from '../../containers/TransactionVerifyContainer';

function Layout1({ logout, mapPermissions, session }) {
  const history = useHistory();
  window.h = history;

  const [rtl, setRtl] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [image, setImage] = useState(true);
  const [toggled, setToggled] = useState(false);
  const [titleHeader, setTitleHeader] = useState('');
  const [isLogin, setLogin] = useState(window.localStorage.getItem('isLogin'));

  history.listen((location, action) => {
    setLogin(isLogin);
  });

  const handleCollapsedChange = () => {
    setCollapsed(!collapsed);
  };

  const handleLogOut = () => {
    logout();
    window.$isAuthenticated = false;
    history.push(`${PREFIX_FRONT_URL}/login`);
  };

  const handleRtlChange = (checked) => {
    setRtl(checked);
  };
  const handleImageChange = (checked) => {
    setImage(checked);
  };

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <div className={`app ${rtl ? 'rtl' : ''} ${toggled ? 'toggled' : ''}`}>
      <Router>
        <Aside
          image={image}
          collapsed={collapsed}
          handleToggleSidebar={handleToggleSidebar}
          handleGetTitle={setTitleHeader}
          mapPermissions={mapPermissions}
          session={session}
        />
        <Layout>
          <Header
            history={history}
            image={image}
            toggled={toggled}
            collapsed={collapsed}
            rtl={rtl}
            handleToggleSidebar={handleToggleSidebar}
            handleCollapsedChange={handleCollapsedChange}
            handleLogOut={handleLogOut}
            handleRtlChange={handleRtlChange}
            handleImageChange={handleImageChange}
            title={titleHeader}
          />
          <Switch>
            {/* Home */}
            <Route exact path="/">
              <HomeContainer />
            </Route>
            {/* ORDER */}
            <Route exact path="/order/orders">
              <OrderHistoryContainer />
            </Route>
            <Route exact path="/order-transaction/all">
              <OrderTransactionHistory />
            </Route>

            {/* TRANSACTION */}
            <Route exact path="/transaction/history">
              <TransactionHistoryContainer />
            </Route>
            <Route exact path="/transaction/tx-error">
              <TransactionError />
            </Route>

            {/* USER */}
            <Route path="/user/paginate">
              <ListUserContainer />
            </Route>
            <Route exact path="/user/login-histories">
              <LoginHistoryContainer />
            </Route>

            {/* SETTING */}
            <Route exact path="/settings/transaction-fee">
              <TransactionFee />
            </Route>

            <Route exact path="/settings/coin">
              <ListCoinOnFieldContainer />
            </Route>
            <Route exact path="/settings/order-fee">
              <SettingFeeTransaction />
            </Route>
            <Route exact path="/setting/affiliate-setting">
              <AffilateSettingContainer />
            </Route>

            <Route exact path="/settings/login">
              <LoginSetting />
            </Route>

            {/* TOOL */}
            <Route exact path="/tool/trace-address">
              <ToolsContainer />
            </Route>
            <Route exact path="/tool/campaign">
              <CampaignContainer />
            </Route>
            <Route exact path="/tool/campaign/lucky-game">
              <LuckyGameConfigContainer />
            </Route>
            <Route exact path="/tool/transfer-money">
              <TransferMoneyContainer />
            </Route>
            <Route exact path="/tool/admin-wallet-balance">
              <AdminWalletBalanceContainer />
            </Route>
            <Route exact path="/tool/notification">
              <NotificationContainer />
            </Route>
            <Route exact path="/tool/transaction-verify">
              <TransactionVerifyContainer />
            </Route>

            {/* STATISTIC */}
            <Route exact path="/statistic/inout-order-trans">
              <InOutOrderTransContainer />
            </Route>
            <Route exact path="/statistic/inout-trans">
              <InOutTransContainer />
            </Route>
            <Route exact path="/statistic/inout-trans-external">
              <InOutTransExternalContainer />
            </Route>
            <Route exact path="/statistic/wallet-balance">
              <WalletBalanceContainer />
            </Route>
            <Route exact path="/statistic/affiliate-statistic">
              <AffilateStatisticContainer />
            </Route>

            {/* AUTHORIZATION */}
            <Route exact path="/admin/all-admins">
              <AdminManagementContainer />
            </Route>
            <Route exact path="/admin/limit-transfer-money/:pubkey">
              <LimitTransferMoneyContainer />
            </Route>
            {/* <Route exact path="/authorization/roles"> */}
            {/*  <RoleManagementContainer /> */}
            {/* </Route> */}
            <Route exact path="/authorization/permissions">
              <PermissionManagementContainer />
            </Route>
            {/* <Route exact path="/authorization/controls"> */}
            {/*  <PermissionActionManagementContainer /> */}
            {/* </Route> */}
          </Switch>
        </Layout>
      </Router>
    </div>
  );
}

const mapStateToProps = (state) => ({
  mapPermissions: state.admin.mapPermissions,
  session: state.user.session,
});

const mapDispatchToProps = (dispatch) => ({
  logout(params) {
    dispatch(action.logout(params));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout1));
